import { Badge, Group, Stack, Text } from '@mantine/core'
import {
  VAT0_LABEL,
  VAT_LABEL,
  calculateFinalPrice,
  formatEuros,
  formatEurosVat0,
  roundCents,
} from '@markku/utils'

interface PriceDisplayProps {
  basePrice: string | number | null | undefined
  discountPercent?: number | null
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  showVat0?: boolean
}

function Vat0Display({ price }: { price: number }) {
  return (
    <Text size="xs" c="dimmed">
      {formatEurosVat0(price)} {VAT0_LABEL}
    </Text>
  )
}

export function PriceDisplay({
  basePrice,
  discountPercent,
  size = 'sm',
  showVat0 = false,
}: PriceDisplayProps) {
  const hasDiscount = discountPercent != null && discountPercent > 0
  // ALV 0 comes off the rounded gross, the way Stripe and Fennoa derive it
  const finalPrice = roundCents(calculateFinalPrice(basePrice, discountPercent))

  if (!hasDiscount) {
    return (
      <Stack gap={0}>
        <Group gap={4} wrap="nowrap">
          <Text size={size} fw={500}>
            {formatEuros(finalPrice)}
          </Text>
          {showVat0 && (
            <Text size="xs" c="dimmed">
              {VAT_LABEL}
            </Text>
          )}
        </Group>
        {showVat0 && <Vat0Display price={finalPrice} />}
      </Stack>
    )
  }

  return (
    <Stack gap={0}>
      <Group gap="xs" wrap="nowrap">
        <Text size={size} c="dimmed" td="line-through">
          {formatEuros(basePrice)}
        </Text>
        <Badge size="xs" variant="light" color="green">
          -{discountPercent}%
        </Badge>
        <Text size={size} fw={500}>
          {formatEuros(finalPrice)}
        </Text>
        {showVat0 && (
          <Text size="xs" c="dimmed">
            {VAT_LABEL}
          </Text>
        )}
      </Group>
      {showVat0 && <Vat0Display price={finalPrice} />}
    </Stack>
  )
}
